"use strict";

var _themeSections = require("@shopify/theme-sections");

require("../sections/ebooks");
/**
 * Template: Index
 * -----------------------------------------------------------------------------
 * Scripts to execute on the index page.
 *
 */


document.addEventListener('DOMContentLoaded', function () {
  (0, _themeSections.load)('*');
});